import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SubmitCancelComponent } from "@Common/events";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { KeyStoreService } from "../key-store.service";
import { SshAgentExtensionService } from '@Common/util';

@Component({
standalone: false,
  selector: 'fx-public-key',
  templateUrl: './public-key.component.html',
  styleUrls: ['./public-key.component.css']
})
export class PublicKeyComponent extends SubmitCancelComponent implements OnInit {
  form: FormGroup;
  @Output () error= new EventEmitter ();
  disabled = false;
  private i = 0;
  private MAXTRIES = 3;
  constructor(private fb: FormBuilder, private sshAgent: SshAgentExtensionService,) {
    super ();
   }
  
  update () {
    this.ngOnInit ();
  }
  async ngOnInit() {
    this.disabled = false;
    this.form = this.fb.group({
        passphrase: ''
    });
  }
  onSubmit ($event) {
    this.submit.emit ($event);
  }
  onCancel () {
    this.disabled = false;
    this.cancel.emit ();
  }
  disableDecrypt () {
    return this.sshAgent.agentConnected() 
  }
  onDecryptError (e) {
    this.disabled = false;
    this.i++;
    this.error.emit (e);
    if (this.i < this.MAXTRIES) return;
   ;    
  }
}
